import { Component, OnDestroy, OnInit, Renderer2 } from '@angular/core';
import { Router } from '@angular/router';

import { LayoutService } from 'src/app/layout/services/layout.service';
import { MessagesService } from 'src/app/system/services/message.service';
import { StorageEnum } from '../core/enums/StorageEnum';
import { UserService } from '../services/user.service';

@Component({
  selector: 'app-layout',
  templateUrl: './app.layout.component.html',
  styleUrls: ['./app.layout.component.scss'],
})
export class AppLayoutComponent implements OnDestroy, OnInit {
  model: any[] = [];
  menuOutsideClickListener: any;
  menuScrollListener: any;

  constructor(
    private user: UserService,
    public layoutService: LayoutService,
    public renderer: Renderer2,
    public router: Router,
    public MessagesService: MessagesService
  ) { }

  ngOnInit(): void {
    this.model = [
      {
        label: 'Atención a Cliente',
        icon: 'pi pi-home',
        items: [
          {
            label: 'Calendario',
            icon: 'fa fa-calendar',
            routerLink: ['/company/job-center/events/calendar']
          },
          {
            label: 'Cotizaciones',
            icon: 'fa fa-file-text-o',
            routerLink: ['/company/job-center/quotes']
          },
          {
            label: 'Clientes',
            icon: 'fa fa-users',
            routerLink: ['/company/job-center/customers']
          },
        ]
      },
      {
        label: 'Administrativo', icon: 'pi pi-briefcase',
        items: [
          {
            label: 'Recursos humanos', icon: 'fa-solid fa-users-rays',
            items: [
              {
                label: 'Empleados', icon: 'fa-solid fa-users',
                routerLink: '/company/job-center/administrative/employees'
              },
            ]
          },
          {
            label: 'Inventario', icon: 'fa-solid fa-warehouse',
            items: [
              {
                label: 'Proveedores', icon: 'fa-solid fa-building-user',
                routerLink: '/company/job-center/inventory/providers'
              },
              {
                label: 'Productos', icon: 'fa-solid fa-flask',
                routerLink: '/company/job-center/inventory/products'
              },
              {
                label: 'Almacenes', icon: 'fa-solid fa-dolly',
                routerLink: '/company/job-center/inventory/warehouses'
              },
              {
                label: 'Ordenes de Compra', icon: 'fa-solid fa-file-invoice',
                routerLink: '/company/job-center/inventory/purchase-orders'
              },
              {
                label: 'Traspasos', icon: 'fa-solid fa-exchange',
                routerLink: '/company/job-center/inventory/transfers'
              },
              {
                label: 'Entradas', icon: 'fa-solid fa-external-link-square',
                routerLink: '/company/job-center/inventory/entrys'
              },
              {
                label: 'Ajustes', icon: 'fa-solid fa-sliders',
                routerLink: '/company/job-center/inventory/adjustments'
              },
            ]
          },
          /* {
            label: 'Gastos',
            icon: 'fa fa-money',
            routerLink:   '/company/job-center/administrative/expenses'
          },
          {
            label: 'Remisiones',
            icon: 'fa fa-credit-card',
            routerLink: '/company/job-center/administrative/referrals'
          }, */
        ]
      },
      {
        label: 'Ajustes', icon: 'pi pi-cog',
        items: [
          {
            label: 'Catálogos', icon: 'fa fa-list',
            items: [
              {
                label: 'Cotizaciones', icon: 'pi pi-wallet',
                routerLink: '/company/job-center/catalogs/quotes'
              },
              {
                label: 'Servicios', icon: 'pi pi-server',
                routerLink: '/company/job-center/catalogs/services'
              },
              {
                label: 'Monitoreo', icon: 'pi pi-desktop',
                routerLink: '/company/job-center/catalogs/monitoring'
              },
              {
                label: 'Productos', icon: 'pi pi-align-right',
                routerLink: '/company/job-center/catalogs/products'
              },
              {
                label: 'Contabilidad',
                icon: 'pi pi-money-bill',
                routerLink: '/company/job-center/catalogs/acounting'
              },
              {
                label: 'Calendario', icon: 'pi pi-calendar',
                routerLink: '/company/job-center/catalogs/calendar'
              },
              {
                label: 'Recursos Humanos', icon: 'pi pi-users',
                routerLink: '/company/job-center/catalogs/human-resources'
              },
              {
                label: 'Tickets', icon: 'pi pi-ticket',
                routerLink: '/company/job-center/catalogs/tickets'
              },
              {
                label: 'Plan de acción', icon: ' pi pi-bolt',
                routerLink: '/company/job-center/catalogs/action-plan'
              },
              {
                label: 'Tareas', icon: 'pi pi pi-book',
                routerLink: '/company/job-center/catalogs/tasks'
              },
            ]
          },
        ]
      },
    ];

    this.layoutService.onMenuClose();
    this.changeTheme(this.user.Company.web_color)
  }

  ngOnDestroy() {
    localStorage.removeItem(StorageEnum.JOB_CENTER);
    this.layoutService.onMenuOpen();
  }

  navigate(item: any) {
    if (Array.isArray(item.routerLink)) {
      this.router.navigate(item.routerLink);
    } else {
      this.router.navigateByUrl(item.routerLink);
    }
  }


  changeTheme(theme: string) {
    const themeLink = <HTMLLinkElement>document.getElementById('theme-link');
    const newHref = themeLink.getAttribute('href')!.replace(this.layoutService.config.theme, theme);

    this.replaceThemeLink(newHref, () => {
      this.layoutService.config.theme = theme;
      this.layoutService.onConfigUpdate();
    });
  }

  replaceThemeLink(href: string, onComplete: Function) {
    const id = 'theme-link';
    const themeLink = <HTMLLinkElement>document.getElementById(id);
    const cloneLinkElement = <HTMLLinkElement>themeLink.cloneNode(true);

    cloneLinkElement.setAttribute('href', href);
    cloneLinkElement.setAttribute('id', id + '-clone');

    themeLink.parentNode!.insertBefore(cloneLinkElement, themeLink.nextSibling);

    cloneLinkElement.addEventListener('load', () => {
      themeLink.remove();
      cloneLinkElement.setAttribute('id', id);
      onComplete();
    });
  }
}

